import { ModalTemplate } from '../ModalTemplate';
import { RemoteControlReason } from 'providers/types/remoteControl';
import { ReasonList } from './ReasonList';
import { ReactNode } from 'react';

interface ReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  reasonList: RemoteControlReason[];
  onSelectReason: (reason: RemoteControlReason) => void;
  title: string;
  iconTitle?: ReactNode;
}

export const ReasonModal: React.FC<ReasonModalProps> = ({
  isOpen,
  onClose,
  onSelectReason,
  reasonList,
  title,
  iconTitle,
}) => (
  <ModalTemplate
    padding={24}
    isOpen={isOpen}
    onClose={onClose}
    centralizedText
    imageText={(
      <ReasonList
        reasons={reasonList}
        onSelectReason={onSelectReason}
      />
      )}
    iconTitle={iconTitle}
    title={title}
  />
);
